import React, { useState } from "react";
import { Venta as VentaModel } from "../../services/ventasServicios";
import { Card, Col } from "react-bootstrap";
import { formatearTiempo, stringADate } from "../../utils/dateUtils";
import { currencyFormat } from "../../utils/numberUtils";
import CardTitle from "../organisms/CardTitle";
import { AgendamientoResumido } from "../../services/agendamientosServicios";
import { AgendamientosResumidos } from "../agendamientosResumidos/AgendamientosResumidos";
import DetailsTableSection from "./DetallesVentaTableSection";
import PagosTableSection from "./PagosTableSection";
import styled from "styled-components";
import SuccessButton from "../organisms/SuccessButton";
import DevolucionesTableSection from "./DevolucionesTableSection";
import NotasCreditoTableSection from "./NotasCreditoTableSection";

export type VentaProps = {
  venta: VentaModel;
  agendamientos: AgendamientoResumido[] | undefined;
  agendamientosIsLoading: boolean;
  agendamientosIsSuccess: boolean;
  onPagarClick: () => void;
};

export const Venta = ({
  venta,
  agendamientos,
  agendamientosIsLoading,
  agendamientosIsSuccess,
  onPagarClick,
}: VentaProps) => {
  const [mostrarAgendamientos, setMostrarAgendamientos] =
    useState<boolean>(false);

  return (
    <StyledCard>
      <StyledCardHeader className="mt-3">
        <Col>
          <CardTitle>{"Detalles de venta"}</CardTitle>
        </Col>
      </StyledCardHeader>
      <StyledCardBody>
        <div className="mb-3">
          <b>{"Fecha: "}</b>
          {formatearTiempo(stringADate(venta.fecha))}
        </div>
        <div className="mb-3">
          <b>{"Propietario: "}</b>
          {venta.nombresPropietario}
        </div>
        <div className="mb-3">
          <b>{"Total: "}</b>
          {currencyFormat(venta.total)}
        </div>
        <div className="mb-3">
          <b>{"Pendiente: "}</b>
          {currencyFormat(venta.pendiente)}
        </div>
        {venta.pendiente > 0 && (
          <div className="mb-3">
            <SuccessButton onClick={onPagarClick}>Pagar</SuccessButton>
          </div>
        )}
        {agendamientosIsSuccess && (agendamientos || []).length > 0 && (
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="flexSwitchCheckDefault"
              checked={mostrarAgendamientos}
              disabled={agendamientosIsLoading}
              onChange={() => {
                setMostrarAgendamientos((prev) => !prev);
              }}
            />
            <label>Mostrar agendamientos</label>
          </div>
        )}
        {mostrarAgendamientos &&
          agendamientosIsSuccess &&
          (agendamientos?.length || 0) > 0 && (
            <div className="mt-4">
              <AgendamientosResumidos agendamientos={agendamientos!!} />
            </div>
          )}
        <DetailsTableSection detalles={venta!.detalles} />

        <br />
        <PagosTableSection pagos={venta!.pagos} />
        <DevolucionesTableSection devoluciones={venta!.devoluciones} />
        <NotasCreditoTableSection notasCredito={venta!.notasCredito} />
      </StyledCardBody>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: start;
  align-items: center;
  border: 0px;
`;
